const PAYMENT_LINKS_TABLE_HEADERS = [
  {
    name: 'Payment Name',
    column: 'name'
  },
  {
    name: 'Amount',
    column: 'currency_amount'
  },
  {
    name: 'Created On',
    column: 'created_on'
  },
  {
    name: 'Last Used',
    column: 'last_used'
  },
  {
    name: '',
    column: 'view_link'
  },
  {
    name: '',
    column: 'qr_code'
  },
  {
    name: '',
    column: 'copy_or_delete_link'
  }
];

export { PAYMENT_LINKS_TABLE_HEADERS };
